import * as React from "react";
import { IServices } from "./IServices";

// To be used as a React component, ServiceContext must be capitalized
// eslint-disable-next-line @typescript-eslint/naming-convention
const ServiceContext = React.createContext<IServices | null>(null);

/**
 * The props for the service provider
 */
export interface IServiceProviderProps {
  /**
   * The services
   */
  services: IServices;
}

/**
 * The Service provider component
 *
 * @param props - the service provider properties
 * @returns - the component JSX
 */
export const ServiceProvider: React.FC<React.PropsWithChildren<IServiceProviderProps>> = (props) => {
  return <ServiceContext.Provider value={props.services}>{props.children}</ServiceContext.Provider>;
};

/**
 * Gets the services
 *
 * @returns - The services
 */
export const useServices = (): IServices => {
  const services = React.useContext(ServiceContext);
  if (!services) {
    throw new Error("There is no active service context.");
  }

  return services;
};
